import React from "react";
import {
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import { CreditCard } from "lucide-react";
import PaymentMethodCart from "./PaymentMethodCart";
import { useTranslation } from "react-i18next";

export default function CartAccordionItem5({
  cartList,
  authToken,
  id,
  restaurantDetail,
  handleCartList,
  handleAccordionClick,
}) {
  const { t } = useTranslation();
  return (
    <div>
      {cartList?.orderingMethod?.ordering_method === "in_restaurant" && (
        <AccordionItem value="item-5">
          <AccordionTrigger>
            <div className="flex space-x-3">
              <div>
                <CreditCard />
              </div>
              <div>{t("cart.payment_method.title")}</div>
            </div>
          </AccordionTrigger>
          <PaymentMethodCart
            cartList={cartList}
            authToken={authToken}
            id={id}
            restaurantDetail={restaurantDetail}
            handleCartList={handleCartList}
            handleAccordionClick={handleAccordionClick}
          />
        </AccordionItem>
      )}
    </div>
  );
}
